import React, { Component } from "react";
import ReactModal from "react-modal";
import Loader from "../../loader/loader";

export default class ExportCSVModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            export_size: "all",
        };
    }
    render() {
        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-residue-modal Add-residual add-member-modal export-csv-modal"
            >
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-header">
                    <h4 className="text-left">Export CSV</h4>
                </div>
                <div className="modal-body">
                    <p>Please choose your export file size.</p>
                    <input
                        type="radio"
                        name="export_size"
                        onChange={(e) =>
                            this.setState({ export_size: "loaded" })
                        }
                        checked={this.state.export_size == "loaded"}
                    />{" "}
                    Export Loaded Rows
                    <br />
                    <input
                        type="radio"
                        name="export_size"
                        onChange={(e) => this.setState({ export_size: "all" })}
                        checked={this.state.export_size == "all"}
                    />{" "}
                    Export All Rows
                </div>
                <div className="modal-footer">
                    <button
                        type="submit"
                        className="btn confirm-button"
                        onClick={() =>
                            this.props.onExportCSVButtonClickHandler(
                                this.state.export_size,
                            )
                        }
                    >
                        Export
                    </button>
                    <button
                        className="btn cancel-button"
                        onClick={() => this.props.handleClose()}
                    >
                        Cancel
                    </button>
                </div>
                {this.props.showExportSpinner ? (
                    <div className="exportFileLoader">
                        <div className="spinner">
                            <Loader />
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </ReactModal>
        );
    }
}
